import Model from './Model'

export default class ReportProcessAnnotation extends Model {
  index: number
  top: number
  left: number
  width: number
  height: number
  choice: number
  description: string

  constructor(annotation, locale) {
    super({})
    this.index = annotation.index
    this.choice = annotation.choice
    this.description = annotation.description
    this.top = annotation.top
    this.left = annotation.left
    this.width = annotation.width
    this.height = annotation.height
  }
}
